import { ANNOUNCEMENT_REQUEST,ANNOUNCEMENT_REQUEST_ERROR, ANNOUNCEMENT_REQUEST_SUCCESS,FORM_REFRESH } from "../actionType/type";

const initialState = {
    data: null,
    isLoading: false,
    refreshPage:false
};

export const manageAnnouncementReducer = (state=initialState,action) => {
    let object;
    switch (action.type) {
        case ANNOUNCEMENT_REQUEST:
            object = {
                ...state,
                isLoading: true,
              }
            break
        case ANNOUNCEMENT_REQUEST_ERROR:
            object = {
                ...state,
                isLoading:false
            }
            break
        case ANNOUNCEMENT_REQUEST_SUCCESS:
            object = {
                ...state,
                data:action.payload,
                isLoading:false
            }
            break
        case FORM_REFRESH:
            object = {
                ...state,
                refreshPage:!state.refreshPage
            }
            break
    
        default:
            object = state
            break
    }
    
    return object
}